import React from 'react';
import Select from 'common/data-entry/Select';
import { sortBy } from 'lodash';

import { SelectedStudyPCN } from 'components/pages/setup/Protocol/ProtocolDetailsStudySelector/SelectedStudyPCN/SelectedStudyPCN';

export const ProtocolDetailsStudySelector = ({ studyListItems, selectedStudy, onChange }) => {
  return (
    <Select
      data-testid="protocol-details-study-selector"
      className="eui-filter-control-study-pcn"
      dataSource={studyListItems ? sortBy(studyListItems, ['name']) : []}
      value={selectedStudy}
      onChange={onChange}
      label="Study"
      searchable={true}
      closeOnSelectedOptionClick={false}
      deselectOnSelectedOptionClick={false}
      clearable={false}
      validate={false}
      customFilterFunction={(e, index, collection, searchString) => {
        return `${e.pcn} ${e.studyName}`.toLowerCase().includes(searchString);
      }}
      customOptionTemplateFunction={e => {
        return (
          <>
            <div className="eui-filter-control-study-pcn-label">{e?.pcn}</div>
            <div className="eui-filter-control-study-name-label">{e?.studyName}</div>
          </>
        );
      }}
      customSelectedValueTemplateFunction={([selectedValue]) =>
        selectedValue ? <SelectedStudyPCN studyName={selectedValue?.studyName} pcn={selectedValue?.pcn} /> : null
      }
    />
  );
};
